import {Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import PaymentMethods from 'components/shared/PaymentMethods/PaymentMethods';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import LinkUI from 'ui/LinkUI';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const Information: FC<IProps> = ({t}) => {
  const links = [
    {link: '/about', keyWord: t('INFORMATION_SUB_TITLE_FOR_US')},
    {link: '/partnership', keyWord: t('INFORMATION_SUB_TITLE_PARTNERS')},
    {link: '/recruitment', keyWord: t('INFORMATION_SUB_TITLE_CAREERS')},
  ];

  return (
    <Flex flexDirection="column" w={['45%', 'auto']}>
      <Text as="h2">{t('INFORMATION')}</Text>
      {links.map((item, index) => (
        <LinkUI href={item.link} key={index}>
          <Text fontSize={['12px', '16px']} fontWeight="500" _hover={{color: colors.pink}} my="4px">
            {item.keyWord}
          </Text>
        </LinkUI>
      ))}
      <Flex mt="20px">
        <PaymentMethods spacing="5px" boxSize={['48px', '64px']} />
      </Flex>
    </Flex>
  );
};
